import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowRight, FaTimes } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import EnquiryImg from "../Assets/Images/EnquireImg.png";

const EnquiryCard = () => {

    const [showCard, setShowCard] = useState(false);
    const [timerId, setTimerId] = useState(null);
    const navigate = useNavigate();

    const openCard = (delay = 2000) => {
        const id = setTimeout(() => {
            setShowCard(true);
        }, delay);
        setTimerId(id);
    };

    useEffect(() => {
        const sessionClosed = sessionStorage.getItem("enquiryCardClosedForSession");

        if (!sessionClosed) {
            openCard(2000);
        }

        // Cleanup
        return () => {
            if (timerId) clearTimeout(timerId);
        };
    }, []);

    const handleClose = () => {
        setShowCard(false);

        if (timerId) clearTimeout(timerId);

        const reopenId = setTimeout(() => {
            setShowCard(true);
        }, 60000);
        setTimerId(reopenId);
    };

    const handleCloseForSession = () => {
        setShowCard(false);
        if (timerId) clearTimeout(timerId);

        sessionStorage.setItem("enquiryCardClosedForSession", "true");
    };

    const handleContactClick = () => {
        navigate("/contactUs", { state: { scroll: true } });
    };

    return (
        <>
            <AnimatePresence>
                {showCard && (
                    <motion.div
                        initial={{ x: 300, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: 300, opacity: 0 }}
                        transition={{
                            type: "spring",
                            stiffness: 100,
                            damping: 12,
                        }}
                        className="fixed bottom-6 right-6 bg-white shadow-2xl rounded-2xl p-5 w-64 z-50 border border-gray-200 flex flex-col items-center text-center"
                    >


                        <h2 className="text-lg font-semibold text-gray-800 mb-2">
                            Request for Enquiry
                        </h2>

                        <img
                            src={EnquiryImg}
                            alt="Enquiry"
                            className="rounded-xl w-full h-[200px] object-contain mb-3"
                        />

                        {/* Contact Button */}
                        <motion.button
                            onClick={handleContactClick}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            className="relative inline-flex items-center justify-center px-5 py-2.5 
              font-medium text-white rounded-lg shadow-lg overflow-hidden
              bg-gradient-to-r from-purple-600 via-pink-600 to-red-600
              transition-all mb-3"
                        >
                            <span
                                className="absolute inset-0 rounded-lg p-[2px] bg-gradient-to-r 
                from-purple-400 via-pink-400 to-red-400 blur-md opacity-75 animate-pulse"
                            ></span>
                            <span className="relative flex items-center">
                                Get an Enquiry
                                <span className="ml-2 text-sm">
                                    <FaArrowRight />
                                </span>
                            </span>
                        </motion.button>

                        {/* New Control Buttons */}
                        <div className="flex flex-col gap-2 w-full mt-1">
                            <button
                                onClick={handleClose}
                                className="text-sm text-gray-700 border border-gray-300 rounded-lg py-1 hover:bg-gray-100 transition"
                            >
                                Close
                            </button>
                            <button
                                onClick={handleCloseForSession}
                                className="text-sm text-gray-700 border border-gray-300 rounded-lg py-1 hover:bg-gray-100 transition"
                            >
                                Close for this session
                            </button>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    )
}

export default EnquiryCard